export var stripeErrorHandler = function stripeErrorHandler(error) {
  if (!error) return;

  switch (error.code) {
    case 'payment_intent_unexpected_state':
      {
        if (error.payment_intent.status === 'succeeded') return;
        break;
      }

    default:
      {
        throw new Error(error.message);
      }
  }
};